<template>
    <div>
        <div class="im-bannerBox">
            <div class="im-bannerInfoBox">
                <div class="im-bannerInfo-title">智能管理</div>
                <div class="im-bannerInfo-title2">覆盖教育机构全部经营环节</div>
                <div class="im-bannerInfo-title2" style="margin-bottom: 80px;">提供全方位解决方案</div>
                <div class="im-bannerInfo-BtnBox">
                    <div  @click="gowe" class="im-bannerInfo-Btn">了解更多</div>
                    <div  @click="popshow = true" class="im-bannerInfo-Btn2">试用</div>
                </div>
            </div>
        </div>
        <div class="im-schedule">
            <div class="im-schedule-title">智能排课</div>
            <div class="im-schedule-title2">Intelligent schedule</div>
            <div class="im-schedule-Box">
                <div class="im-schedule-BoxC">
                    <img class="im-course-t" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-course-t1.png" alt="">
                    <div>创建课程</div>
                </div>
                <img  src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-course-icon.png" alt="">
                <div class="im-schedule-BoxC">
                    <img class="im-course-t" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-course-t2.png" alt="">
                    <div>设置班级</div>
                </div>
                <img  src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-course-icon.png" alt="">
                <div class="im-schedule-BoxC">
                    <img class="im-course-t" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-course-t3.png" alt="">
                    <div>智能排课</div>
                    <div class="im-row">
                        <img class="im-course-cross" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-course-cross.png" alt="">
                        <div class="im-course-crossBox">
                            <div class="im-course-crossBoxC" style="right: -5px;">
                                <img  src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-course-cross-t1.png" alt="">
                                <div class="im-course-crossBoxC-t1">排课表</div>
                                <div class="im-course-crossBoxC-t2">按周排课</div>
                                <div class="im-course-crossBoxC-t2">按天排课</div>
                                <div class="im-course-crossBoxC-t2">循环排课</div>
                            </div>
                            <div class="im-course-crossBoxC">
                                <img  src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-course-cross-t2.png" alt="">
                                <div class="im-course-crossBoxC-t1">排教室</div>
                                <div style="display:flex;flex-direction:column;align-items: flex-start">
                                    <div class="im-course-crossBoxC-t2">排直播教室，可用教</div>
                                    <div class="im-course-crossBoxC-t2">室，适用线上线下教</div>
                                    <div class="im-course-crossBoxC-t2">学</div>
                                </div>
                            </div>
                            <div class="im-course-crossBoxC" style="right: -6px;">
                                <img  src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-course-cross-t3.png" alt="">
                                <div class="im-course-crossBoxC-t1">排教师</div>
                                <div style="display:flex;flex-direction:column;align-items: flex-start">
                                    <div class="im-course-crossBoxC-t2">排教师和助教，可按</div>
                                    <div class="im-course-crossBoxC-t2">课选择教师，也可批</div>
                                    <div class="im-course-crossBoxC-t2">量选择教师</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <img  src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-course-icon.png" alt="">
                <div class="im-schedule-BoxC">
                    <img class="im-course-t" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-course-t4.png" alt="">
                    <div>开班</div>
                </div>
            </div>
        </div>
        <div class="operation-Box">
            <div class="operation-Box-title">智能运营</div>
            <div class="operation-Box-title2">Intelligent operation</div>
            <div class="im-operate-Box">
                <div class="im-operate">
                    <div class="im-operateBox">
                        <div @click="change(0)" class="im-circles-box" style="left: 76px;top: 0;">
                            <img class="im-circles-Icon" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-circular-people.png" alt="">
                            <div>教师管理</div>
                        </div>
                        <div @click="change(1)" class="im-circles-box2" style="left: -38px;top: 137px;">
                            <img class="im-circles-Icon" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-circular-identity.png" alt="">
                            <div>账户管理</div>
                        </div>
                        <div @click="change(2)" class="im-circles-box" style="left: -47px;top: 317px;">
                            <img class="im-circles-Icon" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-circular-book.png" alt="">
                            <div>课程管理</div>
                        </div>
                        <div @click="change(3)" class="im-circles-box2" style="left: 174px;bottom: -58px;">
                            <img class="im-circles-Icon" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-circular-cart.png" alt="">
                            <div>商城管理</div>
                        </div>
                        <div @click="change(4)" class="im-circles-box" style="right: -17px;bottom: 75px;">
                            <img class="im-circles-Icon" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-student.png" alt="">
                            <div>学员管理</div>
                        </div>
                        <div @click="change(5)" class="im-circles-box" style="right: 27px;bottom: 277px;">
                            <img class="im-circles-Icon" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-money.png" alt="">
                            <div>费用管理</div>
                        </div>
                        <div @click="change(6)" class="im-circles-box2" style="right: 0px;top: 67px;">
                            <img class="im-circles-Icon" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-house2.png" alt="">
                            <div>校区管理</div>
                        </div>
                    </div>
                </div>
                <div class="im-operateR">
                    <div v-if="index == 0" class="im-dialogBox">
                        <img class="im-house" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-circular-people.png" alt="">
                        <div class="im-dialogBox-title">教师管理</div>
                        <div class="im-dialogBox-cont">根据数据灵活管理、安排教师资源，合理优化</div>
                        <div class="im-dialogBox-cont">人员配置，使人员利用率最大化</div>
                    </div>
                    <div v-if="index == 1" class="im-dialogBox">
                        <img class="im-house" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-circular-identity.png" alt="">
                        <div class="im-dialogBox-title">账户管理</div>
                        <div class="im-dialogBox-cont">管理用户充值账户，设定充值活动，制定充值</div>
                        <div class="im-dialogBox-cont">规则和兑换规则</div>
                    </div>
                    <div v-if="index == 2" class="im-dialogBox">
                        <img class="im-house" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-circular-book.png" alt="">
                        <div class="im-dialogBox-title">课程管理</div>
                        <div class="im-dialogBox-cont">线上管理多种课程类型，包括体验课、正式课、</div>
                        <div class="im-dialogBox-cont">线上课程、线下课程等</div>
                    </div>
                    <div v-if="index == 3" class="im-dialogBox">
                        <img class="im-house" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-circular-cart.png" alt="">
                        <div class="im-dialogBox-title">商城管理</div>
                        <div class="im-dialogBox-cont">为教育机构建设自己的网上商城，包括商品、</div>
                        <div class="im-dialogBox-cont">订单、物流、发货、库存、配置等业务模块</div>
                    </div>
                    <div v-if="index == 4" class="im-dialogBox">
                        <img class="im-house" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-student.png" alt="">
                        <div class="im-dialogBox-title">学员管理</div>
                        <div class="im-dialogBox-cont">学员信息管理，掌握学生报名缴费及上课情况</div>
                    </div>
                    <div v-if="index == 5" class="im-dialogBox">
                        <img class="im-house" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-money.png" alt="">
                        <div class="im-dialogBox-title">费用管理</div>
                        <div class="im-dialogBox-cont">收支流水详细记录，资金情况实施掌控</div>
                    </div>
                    <div v-if="index == 6" class="im-dialogBox">
                        <img class="im-house" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-house.png" alt="">
                        <div class="im-dialogBox-title">校区管理</div>
                        <div class="im-dialogBox-cont">实现多校区统一管理，实现管理的标准化，提</div>
                        <div class="im-dialogBox-cont">供管理效率</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="popshow" class="pop-bg">
            <div class="pop">
                <img class="pop-logo" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/popup-t1.png" alt="">
                <div class="pop-title">产品试用请联系</div>
                <div class="pop-title2-box">
                    <div class="pop-title2-box-l">
                        <img class="pop-logo2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/popup-t2.png" alt="">
                        <div>手机号：</div>
                    </div>
                    <div class="pop-title2-box-r">15900622304</div>
                </div>
                <div class="pop-title2-box" style="margin-bottom: 38px;">
                    <div class="pop-title2-box-l">
                    </div>
                    <div class="pop-title2-box-r">18862561723</div>
                </div>
                <div class="pop-title2-box">
                    <div class="pop-title2-box-l">
                        <img class="pop-logo2" style="width: 20px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/mailbox.png" alt="">
                        <div>邮箱：</div>
                    </div>
                    <div class="pop-title2-box-r">jenny.wang@unishining.com</div>
                </div>
                <div class="pop-title2-box">
                    <div class="pop-title2-box-l">
                    </div>
                    <div class="pop-title2-box-r">Diana.wu@unishining.com</div>
                </div>
                <div @click="popshow = false" class="pop-out">知道了</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "education-administration",
        data:vm=>{
            return{
                popshow:false,
                index:6,
            }
        },
        methods:{
            gowe(){
                this.$router.push('/we')
            },
            change(index){
                this.index = index
            }
        }
    }
</script>

<style lang="less" scoped>
.im-bannerBox{
    margin-top: 7px ;
    margin-bottom: 76px;
    width: 100%;
    height: 587px;
    background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-bannner.png") center center no-repeat;
    -webkit-background-size: 100% 100%;
    background-size: 100% 100%;
    .im-bannerInfoBox{
        width: 1200px;
        margin: 0 auto;
        box-sizing: border-box;
        padding-top: 135px;
        .im-bannerInfo-title{
            font-size: 32px;
            font-weight: bold;
            margin-bottom: 37px;
        }
        .im-bannerInfo-title2{
            font-size: 28px;
            margin-bottom: 10px;
        }
        .im-bannerInfo-BtnBox{
            display: flex;
            align-items: center;
            .im-bannerInfo-Btn{
                font-size: 16px;
                color: #636363;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 161px;
                height: 47px;
                border: 1px solid #313131;
                cursor: pointer;
            }
            .im-bannerInfo-Btn2{
                width: 161px;
                height: 47px;
                border: 1px solid #313131;
                background: #1B1B1B;
                font-size: 16px;
                color: #fff;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-left: 20px;
                cursor: pointer;
            }
        }
    }
}
.im-schedule{
    width: 1200px;
    margin: 0 auto;
    .im-schedule-title{
        font-size: 32px;
        font-weight: bold;
        text-align: center;
    }
    .im-schedule-title2{
        margin-top: 10px;
        font-weight: 300;
        font-size: 20px;
        text-align: center;
        margin-bottom: 78px;
    }
    .im-schedule-Box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .im-schedule-BoxC{
            position: relative;
            width: 164px;
            height: 164px;
            background: #FFFFFF;
            box-shadow: 0px 1px 24px 0px rgba(13, 5, 10, 0.12);
            border-radius: 20px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 20px;
            font-weight: bold;
            .im-course-t{
                margin-bottom: 20px;
            }
            .im-row{
                position: absolute;
                width: 626px;
                top: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                .im-course-cross{
                    width: 500px;
                }
                .im-course-crossBox{
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    .im-course-crossBoxC{
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        position: relative;
                        .im-course-crossBoxC-t1{
                            margin-top: 20px;
                            margin-bottom: 20px;
                            font-size: 20px;
                            font-weight: bold;
                        }
                        .im-course-crossBoxC-t2{
                            font-size: 16px;
                            font-weight: 500;
                            margin-bottom: 5px;
                        }
                    }
                }
            }
        }
    }
}
.operation-Box{
    box-sizing: border-box;
    padding-top: 64px;
    margin-top: 440px;
    width: 100%;
    height: 891px;
    background: #FAFAFA;
    .operation-Box-title{
        font-size: 40px;
        font-weight: bold;
        text-align: center;
    }
    .operation-Box-title2{
        margin-top: 10px;
        text-align: center;
        font-size: 20px;
        font-weight: 300;
        padding-bottom: 80px;
    }
    .im-operate-Box{
        display: flex;
        justify-content: center;
        align-items: center;
        .im-operate{
            .im-operateBox{
                width: 580px;
                height: 580px;
                position: relative;
                background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-circles.png") no-repeat;
                -webkit-background-size: 100% 100%;
                background-size: 100% 100%;
                .im-circles-box{
                    cursor: pointer;
                    position: absolute;
                    width: 95px;
                    height: 95px;
                    background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-circular-bg.png") no-repeat;
                    -webkit-background-size: 100% 100%;
                    background-size: 100% 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    font-size: 16px;
                    font-weight: 500;
                    color: #000;
                    .im-circles-Icon{
                        margin-bottom: 10px;
                    }
                }
                .im-circles-box2{
                    cursor: pointer;
                    position: absolute;
                    width: 108px;
                    height: 108px;
                    background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-circular-bg2.png") no-repeat;
                    -webkit-background-size: 100% 100%;
                    background-size: 100% 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    font-size: 16px;
                    font-weight: 500;
                    color: #FFFFFF;
                    .im-circles-Icon{
                        margin-bottom: 10px;
                    }
                }
            }
        }
        .im-operateR{
            margin-left: 55px;
            position: relative;
            bottom: 50px;
            right: 10px;
            .im-dialogBox{
                width: 520px;
                height: 310px;
                background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/im-dialog.png") no-repeat;
                -webkit-background-size: 100% 100%;
                background-size: 100% 100%;
                box-sizing: border-box;
                padding-top: 67px;
                padding-left: 129px;
                .im-house{
                    margin-bottom: 16px;
                }
                .im-dialogBox-title{
                    font-size: 24px;
                    font-weight: bold;
                    color: #AB1624;
                    margin-bottom: 30px;
                }
                .im-dialogBox-cont{
                    font-size: 16px;
                    font-weight: 500;
                    color: #000000;
                    margin-bottom: 5px;
                }
            }
        }
    }
}
.pop-bg{
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 99999;
    background: rgba(0,0,0,.5);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .pop{
        width: 395px;
        height: 502px;
        background: #FFFFFF;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .pop-logo{
            margin-bottom: 17px;
        }
        .pop-title{
            font-size: 20px;
            color: #000000;
            margin-bottom: 55px;
        }
        .pop-title2-box{
            display: flex;
            width: 350px;
            .pop-title2-box-l{
                width: 96px;
                font-size: 16px;
                display: flex;
                align-items: center;
                .pop-logo2{
                    margin-right: 11px;
                }
            }
            .pop-title2-box-r{
                color: #B10515;
                font-size: 18px;
            }
        }
        .pop-out{
            width: 172px;
            height: 45px;
            background: #B10515;
            border-radius: 23px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            font-size: 16px;
            cursor: pointer;
            margin-top: 70px;
        }
    }
}
</style>